import React, { useEffect, useState } from 'react'
import ViewPolicyTile from 'src/components/Individual/PolicyDetails/ViewPolicyTile'
import BackArrow from 'src/assets/PolicyDetails_Images/BackArrow.svg'
import Share from 'src/assets/PolicyDetails_Images/Share.svg'
import Notifications from 'src/assets/PolicyDetails_Images/Notifications.svg'
import { Grid, Tooltip, Zoom } from '@mui/material'
import { makeStyles } from '@material-ui/core/styles'
import { getShortAmount } from 'src/utils/commonMethods'
import { useQuery } from '@apollo/client'
import {
  GET_DASHBOARD_POLICIES_GROUP_AGGREGATE,
  GET_POLICY_CITIES,
} from 'src/services/individualService'
import { CircularProgress } from '@material-ui/core'
import GraphQlErrors from 'src/components/common/GraphQlErrors'
import {
  POLICY_STATUS_TYPES,
  POLICY_TYPE_ALL,
  SEARCH_PERSISTENCE_ACTION_TYPES,
  SXP_UPLOAD_POLICY_TYPE,
} from 'src/utils/constants/common'
import { COLORS } from 'src/utils/Themes/colors'
import InsuranceDetails from 'src/components/Individual/InsuranceDetails'
import { getDashboardFilterValue } from 'src/utils/commonMethods/searchPersistence'
import { useDispatch, useSelector } from 'react-redux'
import { setDashboardFilters } from 'src/actions'
import { CustomSearch } from 'src/components/common/custom-components/CustomSearch'
import PolicyCitiesFilters from './PolicyCitiesFilters'

const ViewAllDashboard = ({
  policyDetails,
  handleBack,
  clientId,
  isCEO,
  policyType,
  clientType,
  path,
  expiryType,
  expiredFilterParams,
  prevCity,
  setSelectedCity,
}) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [isInsuranceDetailsOpen, setIsInsuranceDetailsOpen] = useState(false)
  const [selectedPolicy, setSelectedPolicy] = useState({})
  const { viewPolicyDashboardFilters, userInfo } = useSelector((state) => {
    return {
      viewPolicyDashboardFilters:
        state?.searchPersistenceReducer?.viewPolicyDashboardFilters,
      userInfo: state?.userInfo,
    }
  })

  const [filters, setFilters] = useState({
    selectedStatus: getDashboardFilterValue(
      viewPolicyDashboardFilters,
      'selectedStatus',
      POLICY_STATUS_TYPES?.expired
    ),
  })

  const [searchValue, setSearchValue] = useState(
    getDashboardFilterValue(viewPolicyDashboardFilters, 'searchValue', '')
  )
  const [city, setCity] = useState(prevCity)

  const policyCitiesFilters = useSelector(
    (state) => state?.searchPersistenceReducer?.policyCitiesFilters
  )
  const [cityFilters, setCityFilters] = useState({
    city: getDashboardFilterValue(policyCitiesFilters, 'city'),
  })

  const {
    loading: dashboardGroupedPoliciesLoading,
    error: dashboardGroupedPoliciesError,
    data: dashboardGroupedPolicies,
    refetch,
  } = useQuery(
    GET_DASHBOARD_POLICIES_GROUP_AGGREGATE(
      clientId,
      policyDetails?.policyType,
      filters?.selectedStatus,
      searchValue,
      expiryType,
      expiredFilterParams?.year || '',
      (expiredFilterParams?.policyType === POLICY_TYPE_ALL
        ? ''
        : expiredFilterParams?.policyType) || '',
      expiredFilterParams?.subType || '',
      city || ''
    ),
    {
      errorPolicy: 'all',
      fetchPolicy: 'cache-and-network',
    }
  )

  const { data: groupedPoliciesData } = useQuery(
    GET_DASHBOARD_POLICIES_GROUP_AGGREGATE(
      clientId,
      policyDetails?.policyType,
      filters?.selectedStatus,
      searchValue,
      expiryType,
      expiredFilterParams?.year || '',
      expiredFilterParams?.policyType === POLICY_TYPE_ALL
        ? ''
        : expiredFilterParams?.policyType || '',
      expiredFilterParams?.subType || '',
      ''
    ),
    {
      errorPolicy: 'all',
      fetchPolicy: 'cache-and-network',
    }
  )

  const policies =
    dashboardGroupedPolicies?.getDashboardPoliciesGroupedData?.policies

  const PolicyData =
    groupedPoliciesData?.getDashboardPoliciesGroupedData?.policies

  const policyIdsList = PolicyData?.map((policy) => policy?.id) || []

  const {
    loading: policyCitiesLoading,
    error: policyCitiesError,
    data: policyCitiesData,
  } = useQuery(GET_POLICY_CITIES, {
    variables: { policyIds: policyIdsList },
    errorPolicy: 'all',
    fetchPolicy: 'cache-and-network',
  })

  const policyCitiesList = policyCitiesData?.getPolicyCities

  useEffect(() => {
    refetch()
  }, [filters?.selectedStatus, searchValue, refetch, city])

  if (dashboardGroupedPoliciesLoading || policyCitiesLoading)
    return (
      <div>
        <CircularProgress />
      </div>
    )

  if (dashboardGroupedPoliciesError || policyCitiesError)
    return (
      <>
        <GraphQlErrors
          error={dashboardGroupedPoliciesError}
          routeValue={'back'}
        />
      </>
    )

  const handleStatusChange = (status) => {
    setFilters({
      ...filters,
      selectedStatus: status,
    })
  }

  const highlightPolicyContainer = (status) => {
    return filters?.selectedStatus === status
  }

  const closeModal = () => {
    setIsInsuranceDetailsOpen(false)
    setSelectedPolicy({})
  }

  const handlePolicySelect = (policyDetails) => {
    setIsInsuranceDetailsOpen(true)
    setSelectedPolicy(policyDetails)
  }

  const dispatchDashboardFilters = (dashboardFilters, searchText) => {
    dispatch(
      setDashboardFilters(
        SEARCH_PERSISTENCE_ACTION_TYPES?.setViewPolicyDashboardFilters,
        {
          ...dashboardFilters,
          searchValue: searchText,
        }
      )
    )
  }

  const handleSearch = (searchText) => {
    setSearchValue(searchText)
    dispatchDashboardFilters(filters, searchText)
  }

  const dispatchPolicyCitiesFilters = (dashboardFilters, searchText) => {
    dispatch(
      setDashboardFilters(
        SEARCH_PERSISTENCE_ACTION_TYPES?.setPolicyCitiesFilters,
        {
          ...dashboardFilters,
          searchValue: searchText,
        }
      )
    )
  }

  const applyFilters = (event) => {
    setCityFilters({
      ...cityFilters,
      ...event,
    })
    setCity(event?.city)
    dispatchPolicyCitiesFilters(event)
  }

  return (
    <>
      {isInsuranceDetailsOpen ? (
        <div className={classes.insuranceDetailsContainer}>
          <InsuranceDetails
            closeFunction={closeModal}
            activePolicy={selectedPolicy}
            clientId={clientId}
            isCEO={isCEO}
            activePolicyType={policyType}
            path={path}
            policyType={SXP_UPLOAD_POLICY_TYPE?.CORPORATE}
            isCompanyPolicy={true}
          />
        </div>
      ) : (
        <div className={classes.ViewAllPolicyDetailsContainer}>
          <Grid
            container
            spacing={2}
            className={classes.providerDetails}
            justifyContent={'flex-start'}
          >
            <Grid
              item
              xs={12}
              sm={6}
              lg={0.5}
              xl={0.5}
              className={classes.backButton}
              justifyContent={'flex-start'}
            >
              <img
                id='backArrowToPolicyDetails'
                src={BackArrow}
                alt='backarrow'
                className={classes.backArrow}
                onClick={() => {
                  handleSearch('')
                  handleBack()
                }}
              />
            </Grid>
            <Grid item xs={4} sm={2} md={2} lg={1}>
              <span className={classes.headerContains}>
                <img src={policyDetails?.logo} alt='logo'></img>
              </span>
            </Grid>
            <Grid
              item
              xs={8}
              sm={5}
              md={5}
              lg={3}
              className={classes.providerContent}
            >
              <Tooltip
                TransitionComponent={Zoom}
                placement='top'
                title={policyDetails?.policyType}
                arrow
              >
                <span className={classes.policyType}>
                  {policyDetails?.policyType} :
                </span>
              </Tooltip>
              <div className={classes.totalNumberOfPolicies}>
                <span className={classes.providerValue}>
                  {policyDetails?.statistics?.totalNumberOfPolicies}
                </span>
                <span className={classes.providerValueText}>Policies</span>
              </div>
            </Grid>

            <Grid item xs={6} sm={4} md={3} lg={2}>
              <div className={classes.policyDetailsStatistics}>
                <span className={classes.headerKeyFont}>
                  {' '}
                  Total Premium Paid{' '}
                </span>
                <span className={classes.headerValueFont}>
                  {getShortAmount(policyDetails?.totalPremium)}
                </span>
              </div>
            </Grid>
            <Grid item xs={6} sm={4} md={3} lg={2}>
              <div className={classes.policyDetailsStatistics}>
                <span className={classes.headerKeyFont}> Sum Insured </span>
                <span className={classes.headerValueFont}>
                  {getShortAmount(
                    policyDetails?.statistics?.totalSumAssuredAmount
                  )}
                </span>
              </div>
            </Grid>

            <Grid item xs={6} sm={4} md={3} lg={2}>
              <div className={classes.policiesStatusType}>
                <div
                  id='nearToExpire'
                  className={`${classes.policyStatusContainer} ${
                    highlightPolicyContainer(POLICY_STATUS_TYPES?.expiring)
                      ? classes.highlightContainer
                      : null
                  }`}
                  onClick={() =>
                    handleStatusChange(POLICY_STATUS_TYPES?.expiring)
                  }
                >
                  <span className={classes.statusCount}>
                    {policyDetails?.statistics?.expiring}
                  </span>
                  <span>Near to Expire</span>
                </div>

                <div
                  id='expired'
                  className={`${classes.policyStatusContainer} ${
                    highlightPolicyContainer(POLICY_STATUS_TYPES?.expired)
                      ? classes.highlightContainer
                      : null
                  }`}
                  onClick={() =>
                    handleStatusChange(POLICY_STATUS_TYPES?.expired)
                  }
                >
                  <span className={classes.statusCount}>
                    {policyDetails?.statistics?.expired}
                  </span>
                  <span>Expired</span>
                </div>

                <div
                  id='digitalizing'
                  className={`${classes.policyStatusContainer} ${
                    highlightPolicyContainer(POLICY_STATUS_TYPES?.digitalizing)
                      ? classes.highlightContainer
                      : null
                  }`}
                  onClick={() =>
                    handleStatusChange(POLICY_STATUS_TYPES?.digitalizing)
                  }
                >
                  <span className={classes.digitalizingCount}>
                    {policyDetails?.statistics?.digitalizing}
                  </span>
                  <span>Digitalizing</span>
                </div>
              </div>
            </Grid>

            <Grid item xs={6} sm={4} md={3} lg={1.5}>
              <div className={classes.headingIcons}>
                <div className={classes.notificationImage}>
                  <img src={Notifications} alt='notification' />
                </div>
                <div className={classes.shareImage}>
                  <img src={Share} alt='share' />
                </div>
              </div>
            </Grid>
          </Grid>

          <div className={classes.tileCardsContainer}>
            <div className={classes.searchContainer}>
              <PolicyCitiesFilters
                filters={cityFilters}
                applyFilters={applyFilters}
                id={'policyCitiesFilters'}
                citiesList={policyCitiesList}
                onCityChange={setSelectedCity}
              />
              <CustomSearch
                id='searchBar'
                value={searchValue}
                onSearch={handleSearch}
                placeHolder='Search by Policy Number, Vehicle Number'
              />
            </div>
            <Grid container spacing={2}>
              {policies?.map((policyData, index) => (
                <Grid item xs={12} key={`policy_${policyData?.id}`}>
                  <ViewPolicyTile
                    policyData={policyData}
                    handlePolicySelect={() => {
                      handlePolicySelect(policyData)
                    }}
                    policies={policies}
                    userInfo={userInfo}
                    clientId={clientId}
                    clientType={clientType}
                    index={index}
                    policyType={SXP_UPLOAD_POLICY_TYPE?.CORPORATE}
                    path='dashboard/company'
                  />
                </Grid>
              ))}
            </Grid>
          </div>
        </div>
      )}
    </>
  )
}

export default ViewAllDashboard

const useStyles = makeStyles(() => ({
  header: {},

  headerContains: {
    fontSize: '16px',
    fontWeight: 'bold',
    border: '1px',
    borderRadius: '10px 10px 0px 0px',
    padding: '5px',
    flexWrap: 'wrap',
  },
  tileCardsContainer: {
    borderRadius: '0px 0px 15px 15px',
    border: '1px',
    backgroundColor: '#F1EAED',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    padding: '15px',
    flexDirection: 'column',
    gap: '10px',
  },
  policiesStatusType: {
    textAlign: 'initial',
    // padding: '0px 0px 0px 20px',
  },

  textContent: {
    fontSize: '12px',
    fontWeight: '400',
    lineHeight: '14px',
    display: 'flex',
    flexGrow: '1',
    gap: '3px',
  },
  policyStatusContainer: {
    fontSize: '12px',
    fontWeight: '400',
    lineHeight: '14px',
    display: 'flex',
    gap: '3px',
    marginBottom: '5px',
    '&:hover': {
      color: '#B92250',
      padding: '5px',
      transform: 'translateX(0px) scale(1.25)',
      boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.1)',
      cursor: 'pointer',
    },
  },
  textValue: {
    fontSize: '16px',
    fontWeight: '600',
    lineHeight: '21px',
    padding: '5px 0px 0px 0px',
    flexGrow: '1',
  },
  textExpired: {
    fontSize: '14px',
    fontWeight: '600',
    lineHeight: '16px',
    color: '#D80027',
    padding: '5px 0px 0px 0px',
    flexGrow: '1',
  },
  statusCount: {
    color: '#D80027',
    fontSize: '13px',
    fontWeight: '700',
  },
  digitalizingCount: {
    color: '#1192CC',
    fontSize: '13px',
    fontWeight: '700',
  },
  ViewAllPolicyDetailsContainer: {
    border: ' 1px solid #D4CACE',
    borderRadius: '15px',
    display: 'flex',
    flexDirection: 'column',
    margin: '20px 20px 20px 20px',
    justifyContent: 'center',
    flexGrow: '1',
    flexWrap: 'wrap',
  },
  headingIcons: {
    display: 'flex',
    padding: '10px',
    gap: '25px',
    alignItems: 'center',
    flexGrow: '1',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
  },
  backArrow: {
    cursor: 'pointer',
    flexGrow: '1',
  },

  backButton: {
    alignItems: 'flex-start',
  },
  policyDetailsStatistics: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: '18px',
    alignItems: 'center',
  },
  headerValueFont: {
    fontFamily: 'Roboto',
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '21px',
    letterSpacing: '0em',
    textAlign: 'center',
  },
  headerPolicyType: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '14px',
    letterSpacing: '0em',
    textAlign: 'center',
    alignItems: 'flex-start',
  },
  headerKeyFont: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '14px',
    letterSpacing: '0em',
    textAlign: 'center',
  },
  providerDetails: {
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'center',
    flexGrow: '1',
    flexWrap: 'wrap',
    padding: '10px 20px 5px 20px',
  },
  totalNumberOfPolicies: {
    display: 'grid',
    background: '#E8E8E8',
    padding: '6px',
    borderRadius: '3px',
  },
  providerValue: {
    fontSize: '18px',
    fontWeight: '600',
    display: 'flex',
    alignItems: 'center',
    color: '#B92250',
    justifyContent: 'center',
  },
  providerValueText: {
    fontSize: '9px',
    fontWeight: '400',
    color: '#595959',
    textAlign: 'center',
  },
  providerContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
  },
  policyType: {
    fontSize: '14px',
    fontWeight: '400',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '175px',
    whiteSpace: 'nowrap',
  },
  highlightContainer: {
    padding: '5px',
    border: `1px solid ${COLORS.DARK_PINK}`,
    borderRadius: '5px',
  },
  modalRoot: {
    height: '90%',
  },
  insuranceDetailsContainer: {
    textAlign: 'center',
    padding: '10px',
  },
  searchContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
  },
}))
